import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { Container, Typography, Grid, Button } from '../../canvasComponents/index';
import '../../css/domain/Services/Services.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './messages';
import { uberSelector, audatargetSelector, enterpriseSelector } from '../../redux/Services/selectors';
// redux
import { createUberVoucher, createEnterpriseRental, audatargetBookAppointment } from '../../redux/Services/actions';
import { getRouteUrl } from '../../FormioComponents/utils';

function ServicesReview({ claimDetails, onFinalContinue, reviewEdit, noService, uber, enterprise, audatarget, updateCurrentPage, uberVoucher, enterpriseRental, audatargetAppointment }) {
  const dispatch = useDispatch();
  const [uberReady, setUberReady] = useState(!(uber && uber.triggerUber));
  const [enterpriseReady, setEnterpriseReady] = useState(!(enterprise && enterprise.triggerEnterprise));
  const [audatargetReady, setAudatargetReady] = useState(!(audatarget && audatarget.triggerAudatarget));
  const [clickedSubmit, setClickedSubmit] = useState(false);

  // Submit the service info
  const handleServiceSubmission = () => {
    if (uber && uber.triggerUber) {
      dispatch(createUberVoucher(uber.phoneNumber, uber.claimId));
    } else if (enterprise && enterprise.triggerEnterprise) {
      dispatch(createEnterpriseRental(enterprise.gwclaimId, true, enterprise.rentalLocationObj, 'NonDriveable', enterprise.email));
    }
    setClickedSubmit(true);
  };

  useEffect(() => {
    setTimeout(() => {
      document.getElementsByClassName('app')[0].scrollTop = 0;
    }, 100);
    window.history.pushState({}, window.location.pathname, `#/${getRouteUrl(document.querySelector('.services-heading')?.textContent, 'Vehicle') || ''}`);
  }, []);

  useEffect(() => {
    if (uberVoucher.createVoucher.resolved === true) {
      setUberReady(true);
    } if (enterpriseRental.createRental.resolved === true) {
      setEnterpriseReady(true);
    } if (audatargetAppointment.bookAppointment.resolved === true) {
      setAudatargetReady(true);
    }
  }, [uberVoucher.createVoucher.resolved, enterpriseRental.createRental.resolved, audatargetAppointment.bookAppointment.resolved]);

  useEffect(() => {
    if (uberReady && enterpriseReady && clickedSubmit) {
      if (audatargetReady) {
        onFinalContinue();
      } else {
        dispatch(audatargetBookAppointment(audatarget.appointmentAvailability));
      }
    }
  }, [audatargetReady, enterpriseReady, uberReady, clickedSubmit]);

  useEffect(() => {
    updateCurrentPage(messages.reviewYourServices, 9);
  }, []);

  return (
    <Container fluid className="dashboard-content services">
      <Grid>
        <Grid.Row>
          <Typography h1 center className="services-heading">
            <FormattedMessage {...messages.reviewYourServices} />
          </Typography>
        </Grid.Row>
        <div className="services-divider">
          <Grid.Row>
            <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.dateIncident} /></p></Grid.Column>
            <Grid.Column col8 offset1 alignSelfStart><p className="services-review-answer">{claimDetails?.lossDate?.review?.value}</p></Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column col3>
              <p className="services-review-question"><FormattedMessage {...messages.vehicle} /></p>
            </Grid.Column>
            <Grid.Column col8 offset1 alignSelfStart>
              <p className="services-review-answer">{claimDetails?.claim_type?.review?.value}</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column col3>
              <p className="services-review-question"><FormattedMessage {...messages.contact} /></p>
            </Grid.Column>
            <Grid.Column col8 offset1 alignSelfStart>
              <p className="services-review-answer fs-exclude">
                {claimDetails?.container?.policyHolder?.number?.value}
                <br />
                {claimDetails?.container?.policyHolder?.email?.value}
              </p>
            </Grid.Column>
          </Grid.Row>
        </div>
        {/* Uber */}
        {uber && uber.isUberVisible
          && (
            <div className="services-divider">
              <Grid.Row className="mb-14 services-title">
                <Grid.Column col10>
                  <div className="services-section-title"><FormattedMessage {...messages.serviceSelection} /></div>
                </Grid.Column>
                <Grid.Column className="edit-button" col1 offset6 alignSelfEnd>
                  <Button className="edit" onClick={() => { reviewEdit('uber'); uber.previousStep(); }}><FormattedMessage {...messages.editCta} /></Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.servicetype} /></p> </Grid.Column>
                <Grid.Column col8 offset1 alignSelfStart><p className="services-review-answer"><FormattedMessage {...messages.servicetypeUber} /></p></Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.servicetypeDetails} /></p></Grid.Column>
                <Grid.Column col8 offset1 alignSelfStart><p className="services-review-answer fs-exclude"><FormattedMessage {...messages.servicetypeDetailsUber} /> {`(***) ***-${uber.phoneNumber.substring(10, 14)}`}</p></Grid.Column>
              </Grid.Row>
            </div>
          )}
        {/* Enterprise */}
        {enterprise && enterprise.isEnterpriseVisible
          && (
            <div className="services-divider">
              <Grid.Row className="mb-14 services-title">
                <Grid.Column col10>
                  <strong className="services-section-title"><FormattedMessage {...messages.serviceSelection} /></strong>
                </Grid.Column>
                <Grid.Column className="edit-button" col1 offset6 alignSelfEnd>
                  <Button className="edit" onClick={() => { reviewEdit('enterprise'); enterprise.previousStep(); }}><FormattedMessage {...messages.editCta} /></Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.servicetype} /></p> </Grid.Column>
                <Grid.Column col8 offset1 alignSelfStart><p className="services-review-answer"><FormattedMessage {...messages.servicetypeEnterprise} /></p></Grid.Column>
              </Grid.Row>
              {enterprise.branch && (
                <Grid.Row>
                  <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.servicetypeEnterpriseBranch} /> </p></Grid.Column>
                  <Grid.Column col8 offset1 alignSelfStart>
                    <p className="services-review-answer">{enterprise.branch}</p>
                    <p className="services-review-answer">{enterprise.address}</p>
                  </Grid.Column>
                </Grid.Row>
              )}
            </div>
          )}
        {/* Audatarget */}
        {audatarget && audatarget.isAudatargetVisible
          && (
            <div className="services-divider">
              <Grid.Row className="mb-14 services-title">
                <Grid.Column col10>
                  <strong className="services-section-title"><FormattedMessage {...messages.audatargetSelection} /></strong>
                </Grid.Column>
                <Grid.Column className="edit-button" col1 offset6 alignSelfEnd>
                  <Button className="edit" onClick={() => { reviewEdit('audatarget'); audatarget.previousStep(); }}><FormattedMessage {...messages.editCta} /></Button>
                </Grid.Column>
              </Grid.Row>
              {audatarget.repairShop && (
                <Grid.Row>
                  <Grid.Column col3><p><FormattedMessage {...messages.shop} /></p> </Grid.Column>
                  <Grid.Column col8 offset1 alignSelfStart><strong>{audatarget.repairShop}</strong></Grid.Column>
                </Grid.Row>
              )}
              {audatarget.address && (
                <Grid.Row>
                  <Grid.Column col3><p><FormattedMessage {...messages.address} /></p></Grid.Column>
                  <Grid.Column col8 offset1 alignSelfStart>
                    <strong>
                      {audatarget.address?.addressLine1}, {audatarget.address?.province} {audatarget.address?.postalCode}
                    </strong>
                  </Grid.Column>
                </Grid.Row>
              )}
              {(audatarget.appointmentDay || audatarget.appointmentTime) && (
                <Grid.Row>
                  <Grid.Column col3><p><FormattedMessage {...messages.scheduledFor} /></p></Grid.Column>
                  <Grid.Column col8 offset1 alignSelfStart>
                    <strong>
                      <p>{audatarget.appointmentDay}</p>
                      <p>{audatarget.convertToTimeString(audatarget.appointmentTime?.timeFrom)}-{audatarget.convertToTimeString(audatarget.appointmentTime?.timeTo)}</p>
                    </strong>
                  </Grid.Column>
                </Grid.Row>
              )}
            </div>
          )}
        {(noService === 'claim_expert' || (noService === 'own_rental' && !audatarget)) && (
          <div className="services-divider">
            <Grid.Row className="mb-14">
              <Grid.Column col10>
                <strong className="services-section-title"><FormattedMessage {...messages.serviceSelection} /></strong>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column col3><p className="services-review-question"><FormattedMessage {...messages.servicetype} /></p> </Grid.Column>
              <Grid.Column col8 offset1 alignSelfStart>
                <strong>
                  {noService === 'own_rental' && <FormattedMessage {...messages.servicetypeNone} />}
                  {noService === 'claim_expert' && <FormattedMessage {...messages.servicetypeClaimProfessional} />}
                </strong>
              </Grid.Column>
            </Grid.Row>
          </div>
        )}
        <Grid.Row>
          <div className="consent-text-muted">
            <FormattedMessage {...messages.consentFinal} />
          </div>
        </Grid.Row>
        <Grid.Row justifyContentCenter flex>
          <div className="center-v services-btns">
            <Button primary className="mb-20 services-continue-button" onClick={() => handleServiceSubmission()}><FormattedMessage {...messages.submitCta} /></Button>
          </div>
        </Grid.Row>
        <Grid.Row>
          <div className="small-info">
            <FormattedMessage {...messages.informationSecure} />
          </div>
        </Grid.Row>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  uberVoucher: uberSelector(state.services),
  enterpriseRental: enterpriseSelector(state.services),
  audatargetAppointment: audatargetSelector(state.services),
});

export default injectIntl(connect(mapStateToProps)(ServicesReview));
